import Select from "react-select";
import makeAnimated from "react-select/animated";
// import AsyncSelect from 'react-select/async';
import { useState, useEffect } from "react";
// import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
import { findNonAssociatedElements } from "@/utils/frontend/associationOps";

import { humanizeString } from "@/utils/frontend/stringOps";
import useSelectStyles from "./Styles";
const TagsAssociationSelect = ({ callback, tagsTable, tagsLevel, zIndex, target, placeholder, isMulti=true, selectedParent, selectedParentTag, state, lang }) => {

  // console.log("TARGET@TagsAssociationSelect", target)
    //  console.log('tagstable,', tagsTable)
  const animatedComponents = makeAnimated();

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);
  const [selectedTags, setSelectedTags] = useState();
  const [associatedTags, setAssociatedTags] = useState();
 

  // console.log("SelectedParent", selectedParent)
  useEffect(() => {


    // if (target && target.tag) {
    //   // console.log('tarTAgs', target.tags)
    //   let tagsAssociated = [];
   
    //     tagsAssociated.push({ value: target.tag.tag_name_en, label: target.tag.tag_name_en, tag_name_en: target.tag.tag_name_en, tag_name_fr: target.tag.tag_name_fr, tag_level: target.tag.tag_level, tag_colors: target.tag.tag_colors, tag_id: target.tag.tag_id, tag_uuid: target.tag.tag_uuid });

    //   setAssociatedTags(tagsAssociated);
    // }



    if (target && target.tags) {
      // console.log('tarTAgs', target.tags)
      let tagsAssociated = [];
      for (let tag of target.tags) {
        if (tag.tag_snapshot.tag_level === tagsLevel){tagsAssociated.push({ value: tag.tag_snapshot.tag_name_en, label: tag.tag_snapshot.tag_name_en, tag_name_en: tag.tag_snapshot.tag_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, tag_level: tag.tag_snapshot.tag_level, tag_colors: tag.tag_snapshot.tag_colors, tag_id: tag.tag_id, tag_uuid: tag.tag_uuid, 

          tag_snapshot: { //this here is only used for JobPreviewCard
            value: tag.tag_snapshot.tag_name_en, label: tag.tag_snapshot.tag_name_en, tag_name_en: tag.tag_snapshot.tag_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, tag_level: tag.tag_snapshot.tag_level, tag_colors: tag.tag_snapshot.tag_colors, tag_id: tag.tag_id, tag_uuid: tag.tag_uuid,
          }
         });}
      }
      setAssociatedTags(tagsAssociated);
    }

    const getData = async () => {

      try {
        // Only display division (selectedParent) relevant tags 
        if (Number(selectedParent)){
        tagsTable = await tagsTable.filter(tag=> tag.tag_sector_industry.id === selectedParent || tag.tag_sector_industry.id === 0)
        }
        // if (selectedParentTag) {
          // tagsTable = await tagsTable.filter(tag => tag.parent_tag_id === selectedParentTag.id)
        // }
        // if (selectedParent === 'INFORMATION_TECHNOLOGY') { 
        //   tagsTable = await tagsTable.filter(tag=> tag.tag_sector_industry.id === 1 || tag.tag_sector_industry.id === 0)
        // }
        // else if (selectedParent === 'FINANCE') { 
        //   tagsTable = await tagsTable.filter(tag=>tag.tag_sector_industry.id === 2 || tag.tag_sector_industry.id === 0)
        // }
        // else if (selectedParent === 'BUSINESS_CUSTOMER_SUPPORT') { 
        //   tagsTable = await tagsTable.filter(tag=>tag.tag_sector_industry.id === 3 || tag.tag_sector_industry.id === 0)
        // }
        // else if (selectedParent === 'MANUFACTURING') { 
        //   tagsTable = await tagsTable.filter(tag=>tag.tag_sector_industry.id === 4 || tag.tag_sector_industry.id === 0)
        // }
        // else if (selectedParent === 'CONSTRUCTION') { 
        //   tagsTable = await tagsTable.filter(tag=>tag.tag_sector_industry.id === 5 || tag.tag_sector_industry.id === 0)
        // }
        // else if (selectedParent === 'GENERAL_LABOUR') { 
        //   tagsTable = await tagsTable.filter(tag=>tag.tag_sector_industry.id === 99 || tag.tag_sector_industry.id === 0)
        // }
        else {
          tagsTable = []
        }

        let tagMenuOptions = tagsTable?.filter((tag) => {
           // if tagsLevel is passed as an argument, filter tags to match tagsLevel, otherwise, return all tags
          if (tagsLevel) {
            return tag.tag_level === tagsLevel
          } else {
            return tag
          }})
          .map((tag) => {
            return {
              // key: tag.tag_snapshot.tag_name_en,
              id: tag.id,
              value: tag.tag_name_en,
              label: tag.tag_name_en,
              tag_name_en: tag.tag_name_en,
              tag_name_fr: tag.tag_name_fr,
              tag_level: tag.tag_level,
              tag_colors: tag.tag_colors,
              tag_uuid: tag.tag_uuid,

              tag_snapshot: { // only used for JobPreviewCard, just like the redundancy above         
                id: tag.id,
              value: tag.tag_name_en,
              label: tag.tag_name_en,
              tag_name_en: tag.tag_name_en,
              tag_name_fr: tag.tag_name_fr,
              tag_level: tag.tag_level,
              tag_colors: tag.tag_colors,
              tag_uuid: tag.tag_uuid,}
            };
          });
          setData(await tagMenuOptions);
 


        
        // console.log("SELPAR", selectedParent)
        // if (selectedParent === 'FINANCE') { 
        //   // console.log("HERE")
        //   // tagMenuOptions = await tagMenuOptions.filter(tag=>tag.tag_sector_industry.id === 2)
        //   setData(await tagMenuOptions)
        // }
      } catch (error) {
        console.log("error", error);
      }

      // try {
      // const allTags = await axios.get(`/tags/`);
      // let allTagsData = allTags.data;
      // const associatedTags = await axios.get(`/people/tags/filter/person/${person.id}`)
      // let associatedTagsData = associatedTags.data

      // callback({associatedTags: getTagProperties(axios, associatedTagsData)})

      // const nonAssociatedTags = findNonAssociatedElements(allTagsData, 'id', associatedTagsData, 'tag_id')

      // let tagMenuOptions = nonAssociatedTags.filter(tag=>tag.tag_level === tagsLevel).map(tag => {
      //   return {id: tag.id,  value: tag.tag_name_en, label: tag.tag_name_en, name: tag.tag_name_en, type:tag.tag_level, colors:tag.tag_colors, tag_uuid: tag.tag_uuid}
      // })

      // setData(tagMenuOptions);
      // setError(null);
      // return tagMenuOptions
      // } catch(error) {
      // setError(error.message);
      // setData(null);
      // } finally {
      // setLoading(false);
      // }
    };

    getData();



  }, [target, tagsTable, selectedTags, selectedParent]);

  const handleChange = async (newTags) => {
    // if more than 3 level 2 tags are selected, don't add any more tags and raise an alert
    let totalLevel2Tags = Array.isArray(newTags) ? newTags.filter(tag=>tag.tag_level === 2).length : 0
    if (totalLevel2Tags > 3) {
      // alert('3 Tags Max');
      state.setError({message: lang === 'fr' ? "Maximum de 3 tags principaux" : 'Maximum of 3 Primary tags'})
      return false;
    }
    setSelectedTags({ ...selectedTags, newTags });
    // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
    console.log('selectedTags@TagsAssociationSelect', selectedTags)
    await callback({[tagsLevel === 1 ? 'lvlOne' : tagsLevel === 2 ? 'lvlTwo' : 'lvlThree' || 'tags']: {...selectedTags, newTags }});
    // await callback([...selectedTags, ...newTags]);
  };

//   const getValue = () => {
//      return target?.tags.map(tag => {return {value: 's', label: 's'}})
//   }
// target?.tags.map(tag => {return {value: tag.tag_name_en, label: tag.tag_name_en}}
  return (
    <>

      <Select
        isMulti={isMulti}
        // className={`
        // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
        classNamePrefix="select"
        value={selectedTags ? selectedTags.newTags : associatedTags}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        name="currentCompany"
        id="currentCompany"
        onChange={(tag) => {
          handleChange(tag);
        }}
        // value={value}
        options={data}
        // components={animatedComponents}
        menuPlacement="bottom"
        styles={useSelectStyles()}
        placeholder={placeholder}
      />

      {/*
          <div
            style={{
              color: 'hsl(0, 0%, 40%)',
              display: 'inline-block',
              fontSize: 12,
              fontStyle: 'italic',
              marginTop: '1em',
            }}
          >
            <Checkbox
              checked={isClearable}
              onChange={() => setIsClearable((state) => !state)}
            >
              Clearable
            </Checkbox>
            <Checkbox
              checked={isSearchable}
              onChange={() => setIsSearchable((state) => !state)}
            >
              Searchable
            </Checkbox>
            <Checkbox
              checked={isDisabled}
              onChange={() => setIsDisabled((state) => !state)}
            >
              Disabled
            </Checkbox>
            <Checkbox
              checked={isLoading}
              onChange={() => setIsLoading((state) => !state)}
            >
              Loading
            </Checkbox>
            <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
              RTL
            </Checkbox> 
          </div>
          */}
    </>
    //      <>

    // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
    // closeMenuOnSelect={false}
    // components={animatedComponents}
    // // defaultValue={[options[4], options[5]]}
    // isMulti
    // options={data}
    // />
    // </>
  );
};

export default TagsAssociationSelect;

//   <Select
//   // defaultValue={[colourOptions[2], colourOptions[3]]}
//   isMulti
//   name="colors"
//   options={data}
//   className="basic-multi-select"
//   classNamePrefix="select"
// />







// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// // import AsyncSelect from 'react-select/async';
// import { useState, useEffect } from "react";
// // import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
// import { findNonAssociatedElements } from "@/utils/frontend/associationOps";
// import Styles from "./Styles";
// import { humanizeString } from "@/utils/frontend/stringOps";
// const TagsAssociationSelect = ({ callback, tagsTable, tagsType, zIndex, target, placeholder }) => {
//   // console.log("TARGET@TagsAssociationSelect", target)
//     //  console.log('tagstable,', tagsTable)
//   const animatedComponents = makeAnimated();

//   const [data, setData] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isClearable, setIsClearable] = useState(true);
//   const [isSearchable, setIsSearchable] = useState(true);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isRtl, setIsRtl] = useState(false);
//   const [selectedTags, setSelectedTags] = useState();
//   const [associatedTags, setAssociatedTags] = useState();

//   useEffect(() => {

//     if (target && target.tags) {
//       let tagsAssociated = [];
//       for (let tag of target.tags) {
//         if (tag.tag_type === tagsType){tagsAssociated.push({ value: tag.tag_name_en, label: tag.tag_name_en, tag_name_en: tag.tag_name_en, tag_type: tag.tag_type, tag_colors: tag.tag_colors, tag_id: tag.tag_id, tag_uuid: tag.tag_uuid });}
//       }
//       setAssociatedTags(tagsAssociated);
//     }

//     const getData = async () => {
//       try {

    
//         let tagMenuOptions =  tagsTable?.filter((tag) => {
//            // if tagsType is passed as an argument, filter tags to match tagsType, otherwise, return all tags
//           if (tagsType) {
//             return tag.tag_type === tagsType
//           } else {
//             return tag
//           }})
//           .map((tag) => {
//             return {
//               id: tag.id,
//               value: tag.tag_name_en,
//               label: tag.tag_name_en,
//               tag_name_en: tag.tag_name_en,
//               tag_type: tag.tag_type,
//               tag_colors: tag.tag_colors,
//               tag_uuid: tag.tag_uuid,
//             };
//           });
//         setData(await tagMenuOptions);
//      //    setLoading(false)
//       } catch (error) {
//         console.log("error", error);
//       }

//       // try {
//       // const allTags = await axios.get(`/tags/`);
//       // let allTagsData = allTags.data;
//       // const associatedTags = await axios.get(`/people/tags/filter/person/${person.id}`)
//       // let associatedTagsData = associatedTags.data

//       // callback({associatedTags: getTagProperties(axios, associatedTagsData)})

//       // const nonAssociatedTags = findNonAssociatedElements(allTagsData, 'id', associatedTagsData, 'tag_id')

//       // let tagMenuOptions = nonAssociatedTags.filter(tag=>tag.tag_type === tagsType).map(tag => {
//       //   return {id: tag.id,  value: tag.tag_name_en, label: tag.tag_name_en, name: tag.tag_name_en, type:tag.tag_type, colors:tag.tag_colors, tag_uuid: tag.tag_uuid}
//       // })

//       // setData(tagMenuOptions);
//       // setError(null);
//       // return tagMenuOptions
//       // } catch(error) {
//       // setError(error.message);
//       // setData(null);
//       // } finally {
//       // setLoading(false);
//       // }
//     };

//     getData();


//   }, [target, tagsTable, selectedTags]);

//   const handleChange = async (newTags) => {
//     setSelectedTags({ ...selectedTags, newTags });
//     // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
//     console.log('selectedTags@TagsAssociationSelect', selectedTags)
//     await callback({[tagsType || 'tags']: {...selectedTags, newTags }});
//     // await callback([...selectedTags, ...newTags]);

//   };

// //   const getValue = () => {
// //      return target?.tags.map(tag => {return {value: 's', label: 's'}})
// //   }
// // target?.tags.map(tag => {return {value: tag.tag_name_en, label: tag.tag_name_en}}
//   return (
//     <>

//       <Select
//         isMulti
//         // className={`
//         // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
//         classNamePrefix="select"
//         value={selectedTags?.newTags || associatedTags}
//         isDisabled={isDisabled}
//         isLoading={isLoading}
//         isClearable={isClearable}
//         isRtl={isRtl}
//         isSearchable={isSearchable}
//         name="currentCompany"
//         id="currentCompany"
//         onChange={(tag) => {
//           handleChange(tag);
//         }}
//         // value={value}
//         options={data}
//         components={animatedComponents}
//         menuPlacement="bottom"
//         styles={Styles()}
//         placeholder={placeholder}
//       />

//       {/*
//           <div
//             style={{
//               color: 'hsl(0, 0%, 40%)',
//               display: 'inline-block',
//               fontSize: 12,
//               fontStyle: 'italic',
//               marginTop: '1em',
//             }}
//           >
//             <Checkbox
//               checked={isClearable}
//               onChange={() => setIsClearable((state) => !state)}
//             >
//               Clearable
//             </Checkbox>
//             <Checkbox
//               checked={isSearchable}
//               onChange={() => setIsSearchable((state) => !state)}
//             >
//               Searchable
//             </Checkbox>
//             <Checkbox
//               checked={isDisabled}
//               onChange={() => setIsDisabled((state) => !state)}
//             >
//               Disabled
//             </Checkbox>
//             <Checkbox
//               checked={isLoading}
//               onChange={() => setIsLoading((state) => !state)}
//             >
//               Loading
//             </Checkbox>
//             <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
//               RTL
//             </Checkbox> 
//           </div>
//           */}
//     </>
//     //      <>

//     // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
//     // closeMenuOnSelect={false}
//     // components={animatedComponents}
//     // // defaultValue={[options[4], options[5]]}
//     // isMulti
//     // options={data}
//     // />
//     // </>
//   );
// };

// export default TagsAssociationSelect;

// //   <Select
// //   // defaultValue={[colourOptions[2], colourOptions[3]]}
// //   isMulti
// //   name="colors"
// //   options={data}
// //   className="basic-multi-select"
// //   classNamePrefix="select"
// // />















































// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// // import AsyncSelect from 'react-select/async';
// import { useState, useEffect } from "react";
// // import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
// import { findNonAssociatedElements } from "@/utils/frontend/associationOps";
// import Styles from "./Styles";
// import { humanizeString } from "@/utils/frontend/stringOps";
// const TagsAssociationSelect = ({ callback, tagsTable, tagsLevel, zIndex, target, placeholder }) => {
//   // console.log("TARGET@TagsAssociationSelect", target)
//     //  console.log('tagstable,', tagsTable)
//   const animatedComponents = makeAnimated();

//   const [data, setData] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isClearable, setIsClearable] = useState(true);
//   const [isSearchable, setIsSearchable] = useState(true);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isRtl, setIsRtl] = useState(false);
//   const [selectedTags, setSelectedTags] = useState();
//   const [associatedTags, setAssociatedTags] = useState();

//   useEffect(() => {

//     if (target && target.tags) {
//       // console.log('tarTAgs', target.tags)
//       let tagsAssociated = [];
//       for (let tag of target.tags) {
//         if (tag.tag_level === tagsLevel){tagsAssociated.push({ value: tag.tag_name, label: tag.tag_name, tag_name: tag.tag_name, tag_level: tag.tag_level, tag_colors: tag.tag_colors, tag_id: tag.tag_id, tag_uuid: tag.tag_uuid });}
//       }
//       setAssociatedTags(tagsAssociated);
//     }

//     const getData = async () => {
//       try {

    
//         let tagMenuOptions =  tagsTable?.filter((tag) => {
//            // if tagsLevel is passed as an argument, filter tags to match tagsLevel, otherwise, return all tags
//           if (tagsLevel) {
//             return tag.tag_level === tagsLevel
//           } else {
//             return tag
//           }})
//           .map((tag) => {
//             return {
//               id: tag.id,
//               value: tag.tag_name,
//               label: tag.tag_name,
//               tag_name: tag.tag_name,
//               tag_level: tag.tag_level,
//               tag_colors: tag.tag_colors,
//               tag_uuid: tag.tag_uuid,
//             };
//           });
//         setData(await tagMenuOptions);
//      //    setLoading(false)
//       } catch (error) {
//         console.log("error", error);
//       }

//       // try {
//       // const allTags = await axios.get(`/tags/`);
//       // let allTagsData = allTags.data;
//       // const associatedTags = await axios.get(`/people/tags/filter/person/${person.id}`)
//       // let associatedTagsData = associatedTags.data

//       // callback({associatedTags: getTagProperties(axios, associatedTagsData)})

//       // const nonAssociatedTags = findNonAssociatedElements(allTagsData, 'id', associatedTagsData, 'tag_id')

//       // let tagMenuOptions = nonAssociatedTags.filter(tag=>tag.tag_level === tagsLevel).map(tag => {
//       //   return {id: tag.id,  value: tag.tag_name, label: tag.tag_name, name: tag.tag_name, type:tag.tag_level, colors:tag.tag_colors, tag_uuid: tag.tag_uuid}
//       // })

//       // setData(tagMenuOptions);
//       // setError(null);
//       // return tagMenuOptions
//       // } catch(error) {
//       // setError(error.message);
//       // setData(null);
//       // } finally {
//       // setLoading(false);
//       // }
//     };

//     getData();


//   }, [target, tagsTable, selectedTags]);

//   const handleChange = async (newTags) => {
//     setSelectedTags({ ...selectedTags, newTags });
//     // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
//     console.log('selectedTags@TagsAssociationSelect', selectedTags)
//     await callback({[tagsLevel === 1 ? 'lvlOne' : tagsLevel === 2 ? 'lvlTwo' : 'lvlThree' || 'tags']: {...selectedTags, newTags }});
//     // await callback([...selectedTags, ...newTags]);
//   };

// //   const getValue = () => {
// //      return target?.tags.map(tag => {return {value: 's', label: 's'}})
// //   }
// // target?.tags.map(tag => {return {value: tag.tag_name, label: tag.tag_name}}
//   return (
//     <>

//       <Select
//         isMulti
//         // className={`
//         // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
//         classNamePrefix="select"
//         value={selectedTags?.newTags || associatedTags}
//         isDisabled={isDisabled}
//         isLoading={isLoading}
//         isClearable={isClearable}
//         isRtl={isRtl}
//         isSearchable={isSearchable}
//         name="currentCompany"
//         id="currentCompany"
//         onChange={(tag) => {
//           handleChange(tag);
//         }}
//         // value={value}
//         options={data}
//         // components={animatedComponents}
//         menuPlacement="bottom"
//         styles={Styles()}
//         placeholder={placeholder}
//       />

//       {/*
//           <div
//             style={{
//               color: 'hsl(0, 0%, 40%)',
//               display: 'inline-block',
//               fontSize: 12,
//               fontStyle: 'italic',
//               marginTop: '1em',
//             }}
//           >
//             <Checkbox
//               checked={isClearable}
//               onChange={() => setIsClearable((state) => !state)}
//             >
//               Clearable
//             </Checkbox>
//             <Checkbox
//               checked={isSearchable}
//               onChange={() => setIsSearchable((state) => !state)}
//             >
//               Searchable
//             </Checkbox>
//             <Checkbox
//               checked={isDisabled}
//               onChange={() => setIsDisabled((state) => !state)}
//             >
//               Disabled
//             </Checkbox>
//             <Checkbox
//               checked={isLoading}
//               onChange={() => setIsLoading((state) => !state)}
//             >
//               Loading
//             </Checkbox>
//             <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
//               RTL
//             </Checkbox> 
//           </div>
//           */}
//     </>
//     //      <>

//     // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
//     // closeMenuOnSelect={false}
//     // components={animatedComponents}
//     // // defaultValue={[options[4], options[5]]}
//     // isMulti
//     // options={data}
//     // />
//     // </>
//   );
// };

// export default TagsAssociationSelect;

// //   <Select
// //   // defaultValue={[colourOptions[2], colourOptions[3]]}
// //   isMulti
// //   name="colors"
// //   options={data}
// //   className="basic-multi-select"
// //   classNamePrefix="select"
// // />
